<template>

    <div>
        <div class="uk-card uk-card-default uk-card-small uk-card-hover tm-item-card">

            <div class="uk-card-body">

                <!-- image -->
                <div class="tm-item-card-image">
                    <a class="tm-image-link uk-position-relative"
                       :href="ShopItem.href">
                        <img v-if="image.src" :src="image.src">
                        <div v-else class="tm-no-image uk-flex uk-flex-column uk-flex-center uk-flex-middle">
                            <span class="uk-icon uk-margin-xsmall-right" uk-icon="icon: image;ratio: 2;"></span>
                            <span>No image</span>
                        </div>
                    </a>
                </div>

                <!-- Info -->
                <div class="tm-item-card-info">

                    <div class="tm-item-card-info-header">

                        <!-- Title -->
                        <a class="tm-item-card-title"
                           :href="ShopItem.href">{{ ShopItem.name }}</a>

                        <!-- Description -->
                        <div class="tm-item-card-description">
                            <product-properties :properties="ShopItemProperties"></product-properties>
                        </div>

                    </div>

                </div>

            </div>

            <!-- tags -->
            <div v-if="hasSpecialTag === true" class="tm-tags-card">
                <!--<span v-for="tag in ShopItemTags" class="uk-label uk-label-success">{{ tag.ShopItemTag.name }}</span>-->
                <div v-for="tag in ShopItemTags" class="uk-grid uk-grid-small uk-grid-stack">
                    <div v-if="tag.ShopItemTag.id == 4" class="uk-grid-margin"><a
                            class="tm-tag-item tm-new-product-default"
                            :href="tag.ShopItemTag.href"
                            target="_blank"
                            title="Новинки">
                        <img v-if="tag.ShopItemTag.image" :src="tag.ShopItemTag.image.src" class="tm-tag-item-img"
                             alt="Новинка">
                        <span v-else>Новинка</span>
                    </a></div>
                    <div v-if="tag.ShopItemTag.id == 1" class="uk-grid-margin"><a
                            class="tm-tag-item tm-hot-commodity-default"
                            :href="tag.ShopItemTag.href"
                            target="_blank"
                            title="Популярные товары">
                        <img v-if="tag.ShopItemTag.image" :src="tag.ShopItemTag.image.src" class="tm-tag-item-img"
                             alt="Популярный товар">
                        <span v-else>Популярный товар</span>
                    </a></div>
                    <div v-if="tag.ShopItemTag.id == 3" class="uk-grid-margin"><a class="tm-tag-item tm-sale-default"
                                                                                  :href="tag.ShopItemTag.href"
                                                                                  target="_blank"
                                                                                  title="Распродажа">
                        <img v-if="tag.ShopItemTag.image" :src="tag.ShopItemTag.image.src" class="tm-tag-item-img"
                             alt="Распродажа">
                        <span v-else>Распродажа</span>
                    </a></div>
                </div>
            </div>

            <div class="uk-card-footer">
                <product-prices :shop-order-item="ShopOrderItem"
                                :shop-item="ShopItem"
                                :product-prices="ShopItemPrices"
                                :related-shop-items="RelatedShopItems"
                                :shop-item-warehouses="ShopItemWarehouses"
                                v-on="$listeners">
                </product-prices>
            </div>

        </div>
    </div>

</template>

<script>
    import ProductPrices from './ProductPrices'
    import ProductProperties from './ProductProperties'

    export default {
        name: "Product",
        components: {
            ProductPrices,
            ProductProperties
        },
        props: {
            ShopItem: {
                type: Object,
                required: true
            },
            image: {
                type: Object,
                default() {
                    return {}
                }
            },
            ShopProduct: {
                type: Object,
                default() {
                    return {}
                }
            },
            ShopItemPrices: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            RelatedShopItems: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopItemProperties: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopItemWarehouses: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopItemTags: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopOrderItem: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        computed: {
            inStock() {
                return this.ShopItemWarehouses.some(warehouse => {
                    return warehouse.quantity > 0
                });
            },
            hasSpecialTag() {
                return this.ShopItemTags.some((tag) => {
                    return tag.ShopItemTag.id == 1 || tag.ShopItemTag.id == 4 || tag.ShopItemTag.id == 3
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Product.vue?e9d4e540